var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "search-card-collection-component" }, [
    _c("div", { staticClass: "text__bold text__center modal-header" }, [
      _c(
        "a",
        {
          staticClass: "arrow-back arrow-back__extra",
          on: {
            click: function($event) {
              return _vm.$emit("close")
            }
          }
        },
        [
          _c("img", {
            attrs: {
              src: require("@assets/imgs/arrow-back.svg"),
              alt: "Back Arrow"
            }
          })
        ]
      ),
      _vm._v(
        "\n        " + _vm._s(_vm.$t("POST_FORM.ATTACH_A_CARD")) + "\n    "
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "comments__cardAttach__form" }, [
      _c("div", { staticClass: "flex flex__between flex__row" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.searchKeyWord,
              expression: "searchKeyWord"
            }
          ],
          staticClass: "full__width input__reset bg-transparent",
          attrs: {
            type: "text",
            placeholder: _vm.$t("PLACEHOLDER.SEARCH_CARDS")
          },
          domProps: { value: _vm.searchKeyWord },
          on: {
            input: [
              function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.searchKeyWord = $event.target.value
              },
              _vm.searchAttach
            ]
          }
        }),
        _vm._v(" "),
        _c("span", {
          staticClass: "icon icon-main-nav-search",
          on: { click: _vm.searchAttach }
        })
      ])
    ]),
    _vm._v(" "),
    _vm.searchKeyWord
      ? _c(
          "div",
          { staticClass: "comments__cardAttach__results" },
          [
            _vm.searchProgress
              ? _c("div", { staticClass: "spinner text-center" }, [
                  _c("div", { staticClass: "spinner-border" })
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.searchedAttachments.length == 0
              ? _c("div", { staticClass: "no-items" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$t("ERROR_MESSAGE.NO_SEARCH_RESULT")) +
                      "\n        "
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm._l(_vm.searchedAttachments, function(attach_group) {
              return _c("div", { key: attach_group.$index }, [
                attach_group.items.length
                  ? _c(
                      "div",
                      [
                        _c(
                          "div",
                          { staticClass: "comments__cardAttach__label" },
                          [
                            _vm._v(
                              "\n                    " +
                                _vm._s(
                                  attach_group.type === "my"
                                    ? _vm.$t("FEED.MY")
                                    : _vm.$t("FEED.OTHER")
                                ) +
                                "\n                "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _vm._l(attach_group.items, function(item) {
                          return _c("SearchItem", {
                            key: item.$index,
                            attrs: {
                              img_src: _vm.getImgUrl(item),
                              sub_title: _vm.getTypeLabel(item),
                              title: item.title || item.name
                            },
                            on: {
                              click: function($event) {
                                return _vm.handleChooseSearchedItem(item)
                              }
                            }
                          })
                        })
                      ],
                      2
                    )
                  : _vm._e()
              ])
            })
          ],
          2
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "modal-footer text__right" },
      [_c("CreateCardBtn")],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }